import { TBannerItem, TTextModule } from "services/page/admin";
import { LITBLANGS } from "utils/lan";
import { CommonRuntime } from "utils/runtime";
enum ImgKeyType {
	Img = "img",
	ImgTwo = "imgTwo",
}

/**
 * 多语言文字适配
 * @param text: TTextModule | TProductModule
 */
export const multilingualTextDisplay = (text: TTextModule, lan: string) => {
	if (text.ig?.igroup?.[lan]) {
		return text.ig.igroup[lan].text || text.ig.igroup.en.text;
	}
	return text.content;
};

/**
 * 多语言图片适配 (单张图片使用)
 *
 * 判断不分货币？
 *
 * @param img: TBannerItem
 * @param isAtSecond boolean 是否取第二顺位图片（imgtwo）
 */
export const multilingualImgDisplay = (
	img: TBannerItem = {},
	runtime: Partial<CommonRuntime>,
	isAtSecond?: boolean,
) => {
	const imgSrcKey = isAtSecond ? ImgKeyType.ImgTwo : ImgKeyType.Img;
	return (
		img.ig?.igroup?.[runtime.multiLanImgKey]?.[imgSrcKey] ||
		img.ig?.igroup?.[runtime.languageCode]?.[imgSrcKey] ||
		img.ig?.igroup?.[LITBLANGS.EN]?.[imgSrcKey] ||
		img[imgSrcKey] ||
		""
	);
};

/**
 * 多语言链接适配
 * @param text: TBannerItem
 * @returns string
 */
export const multilingualLinkDisplay = (link: TBannerItem, runtime: Partial<CommonRuntime>) => {
	return (
		link.ig?.igroup?.[runtime.multiLanImgKey]?.link ||
		link.ig?.igroup?.[runtime.languageCode]?.link ||
		link?.link ||
		""
	);
};
